/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import nestedProperty from "nested-property";
import moment from "moment";
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule?.getInstance();

export function convertTime(sec: any, displaySeconds = false) {
  let seconds = parseInt(sec, 10);
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds - hours * 3600) / 60);
  let sc = seconds - hours * 3600 - minutes * 60;
  if (displaySeconds) {
    if (!!hours) {
      if (!!minutes) {
        return `${hours}h ${minutes}m ${sc}s`;
      } else {
        return `${hours}h ${sc}s`;
      }
    }
    if (!!minutes) {
      return `${minutes}m ${sc}s`;
    }
    return `${sc}s`;
  }
  if (!!hours) {
    if (!!minutes) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${hours}h`;
    }
  }
  if (!!minutes) {
    return `${minutes}m`;
  }
  return `${sc}s`;
}

const getTokenKey = (tokenId: string) => {
  let tokenName = tokenId;
  if (tokenId?.includes("__")) {
    const tokenArray = tokenId.split("__");
    tokenName = tokenArray[1];
  }
  return tokenName;
};

export const processPaymentQDataFormatter = (data: any[]) => {
  const distCenterDetails = storageService?.get("distCenterData", "local");
  let res: any = [];
  if (data) {
    for (const tx of data) {
      let _txObj: any = {
        appCard: null,
        appCardList: [],
        modalData: {},
      };
      try {
        if (tx?.tokenKey) {
          nestedProperty.set(_txObj, "appCard.appCardId", tx.tokenKey);
        }
        if (tx?.isDelegate) {
          let _user = tx?.boxData[0];
          nestedProperty.set(
            _txObj,
            "appCard.appCardTitle",
            `Delegate : ${_user?.delegateName}`
          );
          nestedProperty.set(
            _txObj,
            "appCard.appCardDescription",
            _user?.masqID
          );
        } else if (tx?.boxData) {
          let _user = tx?.boxData[0];
          nestedProperty.set(_txObj, "appCard.appCardTitle", _user?.fullName);
          nestedProperty.set(
            _txObj,
            "appCard.appCardDescription",
            _user?.masqID
          );
        }
        if (tx?.createdOn) {
          const currentTime = moment(moment().toISOString());
          const foundTime = moment(tx?.createdOn);
          const seconds = currentTime.diff(foundTime, "seconds");
          const waitingTime = convertTime(seconds);
          nestedProperty.set(_txObj, "appCardList.0.name", "Waiting Time");
          nestedProperty.set(_txObj, "appCardList.0.value", waitingTime);
        }
        if (tx?.tokenKey) {
          const token = getTokenKey(tx.tokenKey);
          nestedProperty.set(_txObj, "appCardList.1.name", "Token");
          nestedProperty.set(_txObj, "appCardList.1.value", token);
        }
        if (tx?.boxData) {
          const token = getTokenKey(tx.tokenKey);
          const currentTime = moment(moment().toISOString());
          const foundTime = moment(tx?.createdOn);
          const seconds = currentTime.diff(foundTime, "seconds");
          const waitingTime = convertTime(seconds);
          const isCallout =
            distCenterDetails?.paymentCounter === tx?.lockedByDistCounter &&
            tx?.isCalledOutByDistCounter;
          nestedProperty.set(_txObj, "modalData.boxes", tx.boxData);
          nestedProperty.set(_txObj, "modalData.token", token);
          nestedProperty.set(_txObj, "modalData.waitingTime", waitingTime);
          nestedProperty.set(_txObj, "modalData.otherData", tx);
          nestedProperty.set(_txObj, "modalData.isCallout", isCallout);
        }
        res.push(_txObj);
      } catch (err: any) {
        console.log("error in token data formatting", err);
      }
    }
  }
  return res;
};
